export default __webpack_public_path__ + "static/sales-analytics-reports-92f3f5796a26767cf5dd8228f58d0968.mp4";